module.exports = __webpack_public_path__ + "static/media/asepsis-logo.66c14fa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/containers/Login/asepsis-logo.svg
// module id = 1891
// module chunks = 0